import React from 'react';

const WaitTime = ({ width = '16', height = '16', className, ...rest }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      {...rest}
    >
      <path
        d="M8 4.5V8L10.3333 9.16667"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.3326 13.3429C9.28411 13.801 8.12405 13.9405 6.99683 13.7443C5.8696 13.548 4.82499 13.0246 3.99298 12.2391C3.16098 11.4537 2.57834 10.4409 2.31758 9.32685C2.05681 8.21278 2.12944 7.04662 2.52642 5.97351C2.92339 4.9004 3.62719 3.96773 4.55022 3.29158C5.47324 2.61543 6.57473 2.22566 7.7176 2.17078C8.86046 2.1159 9.99423 2.39833 10.9778 2.98292C11.9614 3.56751 12.7513 4.42845 13.2493 5.45858"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6641 7.71094V11.2109"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6641 13.5391H12.6707"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default WaitTime;
